<div *ngFor="let entry of entries" [ngSwitch]="entry.value.type">
	<ng-container *ngSwitchCase="'object'">
		<nz-card style="width: 100%" class="mb-3" nzTitle="{{ entry.value.title | translate }}">
				<app-card-style-renderer
					[property]="entry.property" [schema]="entry.value" [schemaKey]="entry.key"
					[data]="data" [formConfig]="formConfig" [required]="entry.required" (valid)="setValid($event)"></app-card-style-renderer>
		</nz-card>
	</ng-container>
	<ng-container *ngSwitchDefault>
		<app-card-style-renderer
			[property]="entry.property" [schema]="entry.value" [schemaKey]="entry.key"
			[data]="data" [formConfig]="formConfig" [required]="entry.required" (valid)="setValid($event)"></app-card-style-renderer>
	</ng-container>
</div>
